import React from 'react';
import PropTypes from 'prop-types';
import { View } from 'react-native';

import { createContainer } from '@dbk-legacy/muster/react';
import Text from '@dbk/ui-text';
import { Large, Small } from '../common/text';
import { StylePropType } from '../../utils/prop-types';

import styles from './info-message.styles';
import { VASCO_API_ERROR_CODES } from '../../../src/constants'
import { Message } from '@dbk/ui-forms';

function InfoMessage({
  auth: {
    invalidLogin,
    passwordExpired,
    noEntitlement,
    changePasswordError,
    changePasswordErrorMessage,
    unplannedDowntime,
    errorMsg,
    noRmAccess,
    invalidCredentials,
    eCredPwd,
    isWso2Down
  },
  vascoauthentication: {
    isNTB,
    twoFaRegisPendingCode
  },
  messages,
  style,
}) {
  const containerStyle = [];

  if (invalidLogin && !isWso2Down) {
    containerStyle.push(styles.errorContainer);
    containerStyle.push(style);
    return (
      <div className="row info-message">
        <div className="small-12 text-center" >
          <div className="error-block" tabIndex={0}>
            <Message type="error"> {errorMsg}</Message>
          </div>
        </div>
      </div>
    );
  }

  if (invalidCredentials) {
    containerStyle.push(styles.errorContainer);
    containerStyle.push(style);
    return (

      <div className="row info-message">
        <div className="small-12 text-center" >
          <div className="error-block" tabIndex={0}>
            <Message type="error"> {messages['app.auth.invalidLogin']}</Message>
          </div>
        </div>
      </div>
    );
  }

  if (noRmAccess) {
    containerStyle.push(styles.errorContainer);
    containerStyle.push(style);
    return (

      <div className="row info-message">
        <div className="small-12 text-center" >
          <div className="error-block" tabIndex={0}>
            <Message type="error">{messages['app.login.auth.error.invalidRMAccess']}</Message>
          </div>


        </div>
      </div>

    );
  }

  if (noEntitlement) {
    containerStyle.push(styles.errorContainer);
    containerStyle.push(style);
    return (


      <div className="row info-message">
        <div className="small-12 text-center" >
          <div className="error-block" tabIndex={0}>
             <Message type="error">{messages['app.auth.noEntitlement']}</Message>
          </div>

        </div>
      </div>


    );
  }

  // if (changePasswordError) {
  //   containerStyle.push(styles.infoContainer);
  //   containerStyle.push(style);
  //   return (


  //     <div className="row info-message">
  //       <div className="column small-12 text-center">

  //         <div className="info-block">
  //           <Large>{changePasswordErrorMessage}</Large>
  //         </div>

  //       </div>
  //     </div>




  //   );
  // }

  if (!(isNTB || twoFaRegisPendingCode === VASCO_API_ERROR_CODES.TWOFA_REGISTRATION_PENDING) && passwordExpired) {
    containerStyle.push(styles.infoContainer);
    containerStyle.push(style);
    return (

      <div className="row info-message">
        <div className="small-12 text-center">

          <div className="info-block">
             <Message type="error">{messages['app.auth.passwordExpired.title']} {messages['app.auth.passwordExpired.text']}</Message>
          </div>


        </div>
      </div>

    );
  }


  if(unplannedDowntime)
  {
    containerStyle.push(styles.downTimeMsgStyle);
    containerStyle.push(style);
    return (

      <div className="row info-message">
        <div className="small-12 text-center">

          <div className="info-block">
            <Message type="error">{messages['app.auth.server.unplannedDowntime.title']} {messages['app.auth.server.unplannedDowntime.text']}</Message>
          </div>

        </div>
      </div>


    );
  }

  containerStyle.push(styles.infoContainer);
  containerStyle.push(style);
  return <View />;
}

InfoMessage.propTypes = {
  messages: PropTypes.object.isRequired,
  style: StylePropType,
};

export default createContainer({
  $queries: {
    auth: {
      invalidLogin: true,
      passwordExpired: true,
      errorMsg: true,
      changePasswordError: true,
      changePasswordErrorMessage: true,
      noEntitlement: true,
      unplannedDowntime: true,
      noRmAccess: true,
      invalidCredentials: true,
      eCredPwd: true,
      isWso2Down: true
    },
    vascoauthentication: {
      isNTB: true,
      twoFaRegisPendingCode: true
    }
  },
})(InfoMessage);
